import React from "react";

const Pagination = ({currentPage, lastPage, setCurrentPage}: any) => {
  let pageNumbers = [];
  if (lastPage <= 7) {
    for (let i = 1; i <= lastPage; i++) {
      pageNumbers.push(i);
    }
  }
  else {
    pageNumbers = [
      1,
      2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      lastPage - 1,
      lastPage
    ];

    if (currentPage > 3){
      pageNumbers[1] = '...';
    }
    if (lastPage - currentPage > 3){
      pageNumbers[5] = '...';
    }
    if (currentPage < 5) {
      pageNumbers[2] = 3;
      pageNumbers[3] = 4;
      pageNumbers[4] = 5;
    }
    if (lastPage - currentPage < 3) {
      pageNumbers[2] = lastPage - 4;
      pageNumbers[3] = lastPage - 3;
      pageNumbers[4] = lastPage - 2;
    }
  }

  const next = () => {
    setCurrentPage(Math.min(currentPage + 1, lastPage));
  }

  const prev = () => {
    setCurrentPage(Math.max(currentPage - 1, 1));
  }

  return (
    <div className="tableQuote__pagination">
      <div className="paginationCustom">
        <ul>
          <li className={`previus ${currentPage > 1 ? 'active' : ''}`} onClick={() => prev()}></li>
          {pageNumbers.map((item, index) => 
            <li key={index} className={item === currentPage ? 'active' : ''}
              onClick={() => Number.isInteger(item) && setCurrentPage(item)}
            >{item<10?`0${item}`:`${item}`}</li>
          )}
          <li className={`next ${currentPage < lastPage ? 'active' : ''}`} onClick={() => next()}></li>
        </ul>
      </div>
    </div>
  )
};

export default Pagination;